import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';
import {SharedModule} from '@app/shared/shared.module';
import {EffectsModule} from '@ngrx/effects';
import {AccountListComponent} from './components/account-list/account-list.component';
import {AddAccountComponent} from './components/add-account/add-account.component';
import {EditAccountComponent} from './components/edit-account/edit-account.component';
import {AccountsEffects} from './states/accounts.effects';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        PrimeNgModule,
        FormsModule,
        EffectsModule.forFeature([AccountsEffects]),
        AccountListComponent, AddAccountComponent, EditAccountComponent,
    ],
    exports: [AccountListComponent],
})
export class AccountsModule {}
